var map = {
	"./chainge.jpg": 29147,
	"./coin1.png": 85236,
	"./coin2.png": 7695,
	"./coinavax.png": 95715,
	"./coinbase.png": 86802,
	"./coinbsc.png": 16661,
	"./coineth.png": 50508,
	"./gate.png": 60839,
	"./glider2@2x.png": 89,
	"./inch1.png": 34441,
	"./inch2.png": 69298,
	"./inch3.png": 18299,
	"./kucoin.png": 45093,
	"./kyberdmm.png": 83965,
	"./pan1.png": 6456,
	"./pan2.png": 52211,
	"./panc1.png": 56841,
	"./panc2.png": 42226,
	"./safe1.png": 86764,
	"./safe2.png": 55239,
	"./trust1.png": 68109,
	"./trust2.png": 36342,
	"./uni1.png": 97717,
	"./uni2.png": 11966
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46672;